import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core';
import Alert from "@material-ui/lab/Alert";
import clsx from "clsx";
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(theme => ({
    marginBottom: {
        marginBottom: theme.spacing(2)
    },
    blankMessage: {
        padding: theme.spacing(2)
    }
}));

export default function Message(props) {
    const {
        type,
        children,
        marginBottom = false,
        variant = 'filled'
    } = props;
    const classes = useStyles();

    return type === 'blank' ? (
        <Paper className={classes.blankMessage}>
            {children}
        </Paper>
    ) : (
        <Alert
            variant={variant}
            severity={type}
            className={clsx(marginBottom && classes.marginBottom)}>
            {children}
        </Alert>
    );
}

Message.propTypes = {
    type: PropTypes.string,
    marginBottom: PropTypes.bool,
    variant: PropTypes.string,
    children: PropTypes.any
};